/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
import { createRoot } from 'react-dom/client';

const reuseHmrRoot = (container) => {
  const root = container?.__root || createRoot(container);

  container.__root = root;

  return root;
};

export { reuseHmrRoot as createRoot };
